module.exports = __webpack_public_path__ + "static/img/2345_img_3.51817138.png";